module.exports = __webpack_public_path__ + "static/GLOBAL-LINK-LOGISTICS-logo-32cbcad5201591a9b6336a1be7a8c3ce.png";